import { Portal } from "@mantine/core";

export const portalComponentSettings = Portal.extend({
  defaultProps: {
    reuseTargetNode: false,
  },
});
